import { makeValidated } from '../utils';
import interpolate from '../interpolate';
import schema from '../../schema/set-component-children.schema.json';

const mapSetComponentChildren = action => ({
  type: 'LAYOUT_SET_COMPONENT_CHILDREN',
  payload: {
    value: action.data.value,
    path: action.data.path,
  },
});

const setComponentChildren = (context, event, meta) => {
  const validated = makeValidated(schema);
  return mapSetComponentChildren(
    validated(interpolate(meta.action, event, context))
  );
};

export default setComponentChildren;
